import React from 'react';
import get from 'lodash/get';
import clsx from 'clsx';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';

import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import CountdownTimer from '../../../components/molecules/CountdownTimer';
import Grid from '../../../components/molecules/Grid';
import Box from '../../../components/molecules/Box';
import Picture from '../../../components/atoms/Picture';
import Typography from '../../../components/atoms/Typography';
import useStyles from './style';
import * as locators from './locators';
import { pageContentType } from '../../../utils/getContentType';
import { addLeadingZero, getDateInFormat } from '../../../utils/dateTimeFunctions/dateTimeFunctions';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import NoSsr from '@material-ui/core/NoSsr';
import { EVENT_TYPE } from '../../../../constants/index';
import { getUId } from '../../../../utils/utility';
import { isEmpty } from 'lodash';

// #TODO: Needs to check export.
export const TimerAndTag = props => {
  const contentType = pageContentType(props).toLowerCase();
  const featuredText = getDictionaryText('featuredText');
  let { eventStartDateTime, logoImageUrl, isFeatured = { value: 'text' }, eventCategory } = get(
    props,
    'sitecoreContext.route.fields',
    ''
  );

  eventStartDateTime = { value: getDateInFormat(get(eventStartDateTime, 'value', ''), "MM/DD/YYYY hh:mm:ss A") }

  const eventType = get(eventCategory[0], 'fields.taxonomyValue.value', '')
  const uid = getUId(props);

  const isEventType = contentType === EVENT_TYPE;
  let { backgroundColor = '', textColor = '' } = get(props, 'params', {});
  let displayTimer = true;
  if (!isEventType) {
    eventStartDateTime = get(
      props,
      'sitecoreContext.route.fields.webPageTimer',
      ''
    );
    displayTimer = get(
      props,
      'sitecoreContext.route.fields.displayTimer.value',
      true
    );
  }

  const isFutureDate =
    eventStartDateTime && new Date(eventStartDateTime.value) > new Date();
  const classes = useStyles({
    pageContentType,
    isFeatured,
    logoImageUrl,
    isFutureDate,
    backgroundColor,
    textColor,
  });
  const renderTime = (time, dictKey, hasSeperator = true) => (
    <Box className={classes.dateItem}>
      <Box className={clsx(classes.renderer, 'renderer')}>
        <Typography className={'time-value'} variant="h5" component="span">
          {addLeadingZero(time)}
        </Typography>
        <Typography className={'time-unit'} variant="body2Bold" component="span">
          <Text field={{ value: getDictionaryText(dictKey) }} />
        </Typography>
      </Box>
      {hasSeperator && (
        <Typography variant="h5" component="span">
          :
        </Typography>
      )}
    </Box>
  );

  // #TODO Days, Hours, Mins n Secs needs to take from dictionary
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (!completed) {
      return (
        <Box display="flex" flexDirection="row">
          {renderTime(days, 'Days')}
          {renderTime(hours, 'Hours')}
          {renderTime(minutes, 'Mins')}
          {renderTime(seconds, 'Secs', false)}
        </Box>
      );
    } else {
      return null;
    }
  };

  const shouldComponentRender = () => {
    return isFutureDate;
  };

  const isEventExpired = () => {
    return (eventStartDateTime && new Date(eventStartDateTime.value) < new Date()) || false;
  };

  return (
    <div data-locator={props.dataLocator || locators.COMPONENT_NAME} uid={uid}>
      <NoSsr>
        {shouldComponentRender() && displayTimer ? (
          <Grid
            container
            className={clsx(classes.root, { configurableTimer: !isEventType, AdEvent: isEventType })}
          >
            {!isEventExpired() && isEventType && isFeatured && isFeatured.value && featuredText && (
              <Typography
                variant="labelBlack"
                component="span"
                className={`${classes.tag} eventTimerTag`}
              >
                <Text field={{ value: featuredText }} />
                {/* is same text would come for arabic and chines language */}
              </Typography>
            )}
            {!isEventExpired() && eventType && (
              <Typography
                variant="labelBlack"
                component="span"
                className={`${classes.tag}${isFeatured.value ? '' : ' noFeatured'} eventTimerTag sty2`}
              >
                <Text field={{ value: eventType }} />
                {/* is same text would come for arabic and chines language */}
              </Typography>
            )}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              className={clsx(classes.contentWrapper, 'contentWrapper')}
            >
              {isEventType && logoImageUrl && !isEmpty(logoImageUrl?.value) && (
                <Box className="eventLogo">
                  <Picture
                    media={{
                      image: {
                        value: {
                          src: logoImageUrl.value,
                        },
                      },
                      renditionNeeded: false,
                      fallbackBackgroundNeeded: false,
                    }}
                    isParalax={false}
                  />
                </Box>
              )}
              {eventStartDateTime && eventStartDateTime.value && (
                <Box className="timer">
                  <CountdownTimer
                    date={new Date(eventStartDateTime.value)}
                    renderer={renderer}
                  />
                </Box>
              )}
            </Box>
          </Grid>
        ) : null}
      </NoSsr>
    </div>
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(TimerAndTag))
);
